import { clearLastAction, setLastAction } from "./last-action.actions";
import { Loader } from "../loader";
export const reducers = [
    [
        setLastAction,
        (state, { payload }) => {
            return Object.assign(Object.assign({}, state), { actionType: payload });
        },
    ],
    [
        clearLastAction,
        (state) => {
            return Object.assign(Object.assign({}, state), { actionType: null });
        },
    ],
];
const actionsToIgnore = [
    setLastAction.type,
    clearLastAction.type,
    Loader.Actions.startAction.type,
    Loader.Actions.endAction.type,
];
export const lastActionMiddleware = (store) => (next) => (action) => {
    // Avoid capturing actions internal to the lastaction store to prevent stack overflow
    const isInternalAction = actionsToIgnore.includes(action.type);
    if (!isInternalAction) {
        // Dispatch the action to update the lastAction state and then the 
        // action to clear it so lastaction selectors are fired
        store.dispatch(setLastAction(action.type));
        // Use setTimeout to ensure the action is dispatched before clearing the last action
        setTimeout(() => {
            store.dispatch(clearLastAction());
        }, 0);
    }
    // Continue with the next middleware or reducer
    return next(action);
};
